import { Box, ListItemButton, Typography } from '@mui/material';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export interface KosaViewProps {
    id: number;
    sensorCount: number;
    lastTransaction: string;
    selected?: boolean;
    onClick: (id: number) => void;
}

export default function KosaView({ id, sensorCount, lastTransaction, selected = false, onClick }: KosaViewProps) {
    return (
        <ListItemButton
            onClick={() => onClick(id)}
            selected={selected}
            id={`sidebar-kosa-${id}`}
            sx={{
                borderRadius: 1,
                py: 0.5,
                px: 1.5,
            }}
        >
            <DeviceThermostatIcon sx={{ fontSize: 14, mr: 0.5, flexShrink: 0 }} />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'baseline',
                    flex: 1,
                    minWidth: 0,
                    mr: 1,
                }}
            >
                <Typography variant="body2" noWrap>
                    Коса-{id}
                </Typography>
                <Typography variant="caption" sx={{ ml: 1, flexShrink: 0 }}>
                    {sensorCount} дат
                </Typography>
            </Box>
        </ListItemButton>
    );
}
